import AssessmentCreation from "pages/ManagementPage/AssessmentCreation/AssessmentCreation";

export default AssessmentCreation;
